import { CellRenderType } from '/@/modules/core/table/constants/TableConstant';
import BaseCellRender from './BaseCellRender';

class DocumentsCellRender extends BaseCellRender {
  constructor() {
    super(CellRenderType.DOCUMENTS);
  }
}

export default DocumentsCellRender;
